import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Apply extends Bloc {

	constructor (src, ctx) {

		super("applystatus", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [];
			if (ins[1] === "tension" && ins[2] < 0 && src.spendsTension && src.spendsTension() && (!src.spendsAllTension || !src.spendsAllTension()) && (!src.spendsUpToTension || !src.spendsUpToTension()) && (!src.ignoresTensionSpendModifiers || !src.ignoresTensionSpendModifiers()))
				ins[2] = src.modifyTensionSpend(ins[2]);
			ins[0].apply(ins[1], ins[2], false, src);
			return [];
		};
		this.types = [Types.entity, Types.string, Types.int];
	}
}
